module.exports = __webpack_public_path__ + "img/Caret-Right-2.e88b00ce.svg";